export default __webpack_public_path__ + "ca3e8dc6f2507b3996411c505fe05d48.png";